import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import HomeScreen from "./views/HomeScreen_Container/HomeScreen";
import LoginScreen from "./views/Auth_Container/LoginScreen_Container/LoginScreen";
import { useRecoilValue } from "recoil";
import { authState } from "./Atom";
import Navbar from "./views/mainComponents/Navbar";
import RestaurantScreen from "./views/RestaurantsScreen/RestaurantScreen";
import SingleRestaurant from "./views/RestaurantById/SingleRestaurant";
import CreateRestro from "./views/CreateRestro_Container/CreateRestro";
import RestaurantFloorScreen from "./views/RestaurantFloors/RestaurantFloorScreen";
import EditRestro from "./views/EditRestro_Container/EditRestro";
import CreateSeating from "./views/CreateSeating/CreateSeating";
import SeatLayout from "./views/SeatLayout_Container/SeatLayout";
import Notfound from "./Notfound";
import NavBar from "./Components/NavBar/NavBar";
import Users from "./Components/Users/Users";
import MasterSetting from "./views/MasterSetting/MasterSetting";
import Blogs from "./views/Blogs/Blogs";
import Reservations from "./views/Reservations/Reservations";
import Insights from "./views/Insights/Insights";
import Notifications from "./views/Notifications/Notifications";
import Transactions from "./views/Transactions/Transactions";
import Reports from "./views/Reports/Reports";

const AuthenticatedRoutes = () => {
  return (
    <div>
      {/* <Navbar /> */}
      <NavBar />

      <Switch>
        {/* <Route exact path="/" component={HomeScreen} /> */}
        <Route exact path="/" component={RestaurantScreen} />
        <Route exact path="/users" component={Users} />
        <Route exact path="/restaurants" component={RestaurantScreen} />
        <Route exact path="/restaurants/:id" component={SingleRestaurant} />
        <Route exact path="/createrestaurant" component={CreateRestro} />
        <Route exact path="/restaurant/edit/:id" component={EditRestro} />
        <Route
          exact
          path="/restaurantfloors/:id"
          component={RestaurantFloorScreen}
        />
        <Route exact path="/seatlayout/:floorId/:name" component={SeatLayout} />
        <Route
          exact
          path="/restaurantfloors/seating/:restaurantId/:id/:name"
          component={CreateSeating}
        />
        <Route exact path="/navbar" component={NavBar} />
        <Route exact path="/mastersetting" component={MasterSetting} />
        <Route exact path="/blogs" component={Blogs} />
        <Route exact path="/reports" component={Reports} />
        <Route exact path="/transactions" component={Transactions} />
        <Route exact path="/insights" component={Insights} />
        <Route exact path="/reservations" component={Reservations} />
        <Route exact path="/notifications" component={Notifications} />
        <Route path="/404" component={Notfound} />
        <Redirect from="*" to="/404" />
      </Switch>
    </div>
  );
};

const UnAuthenticatedRoutes = () => {
  return (
    <Switch>
      <Route exact path="/" component={LoginScreen} />
      <Route exact path="/login" component={LoginScreen} />

      <Route path="/404" component={Notfound} />
      <Redirect from="*" to="/404" />
    </Switch>
  );
};

const App = () => {
  const auth = useRecoilValue(authState);

  return (
    <div>
      <Router>
        <Suspense fallback={<div>Loading...</div>}>
          {auth && auth.isAuth ? (
            <AuthenticatedRoutes />
          ) : (
            <UnAuthenticatedRoutes />
          )}
        </Suspense>
      </Router>
    </div>
  );
};

export default App;
